/* eslint-disable import/prefer-default-export */

export const selectCourseTabs = state => state.courseTabs;
